import React from 'react';
import { RadixHoverDropdown, FormFieldV2, SearchFieldV2 } from '@/components/custom/erp';
import { giaoDichSearchColumns, loSearchColumns, viTriSearchColumns } from '@/constants';
import { QUERY_KEYS } from '@/constants/query-keys';
import { useSearchFieldStates } from '../../hooks';
import { Label } from '@/components/ui/label';
import { Lo, ViTri } from '@/types/schemas';

interface OtherTabProps {
  searchFieldStates?: ReturnType<typeof useSearchFieldStates>;
}

const OtherTab: React.FC<OtherTabProps> = ({ searchFieldStates }) => {
  return (
    <div className='space-y-4 p-4'>
      <div className='flex flex-col space-y-3'>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Loại đơn hàng:</Label>
          <div className='w-1/2'>
            <FormFieldV2
              name='ma_ngv'
              type='select'
              options={[
                { value: '__all__', label: '9. Tất cả' },
                { value: '5', label: 'Đơn hàng' },
                { value: '4', label: 'Hợp đồng' }
              ]}
            />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã giao dịch:</Label>
          <div>
            <SearchFieldV2<BanHangRecord>
              type='text'
              searchEndpoint={`/`}
              searchColumns={giaoDichSearchColumns}
              dialogTitle='Giao dịch'
              columnDisplay='transactionCode'
              displayRelatedField='transactionName'
              value={searchFieldStates?.transaction?.transactionCode || ''}
              relatedFieldValue={searchFieldStates?.transaction?.transactionName || ''}
              onRowSelection={searchFieldStates?.setTransaction}
            />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã lô:</Label>
          <div>
            <SearchFieldV2<Lo>
              type='text'
              searchEndpoint={`/${QUERY_KEYS.LO}/`}
              searchColumns={loSearchColumns}
              dialogTitle='Lô hàng'
              columnDisplay='ma_lo'
              displayRelatedField='ten_lo'
              value={searchFieldStates?.lot?.ma_lo || ''}
              relatedFieldValue={searchFieldStates?.lot?.ten_lo || ''}
              onRowSelection={searchFieldStates?.setLot}
            />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã vị trí:</Label>
          <div>
            <SearchFieldV2<ViTri>
              type='text'
              searchEndpoint={`/${QUERY_KEYS.VI_TRI_KHO_HANG}/`}
              searchColumns={viTriSearchColumns}
              dialogTitle='Vị trí'
              columnDisplay='ma_vi_tri'
              displayRelatedField='ten_vi_tri'
              value={searchFieldStates?.location?.ma_vi_tri || ''}
              relatedFieldValue={searchFieldStates?.location?.ten_vi_tri || ''}
              onRowSelection={searchFieldStates?.setLocation}
            />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Diễn giải:</Label>
          <div className='w-2/3'>
            <FormFieldV2 name='dien_giai' type='text' />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mẫu lọc báo cáo:</Label>
          <div>
            <div className='flex items-center gap-1'>
              <div className='w-64'>
                <FormFieldV2
                  name='report_filtering'
                  type='select'
                  options={[{ value: '__all__', label: 'Người dùng tự lọc' }]}
                />
              </div>

              <div className='h-9 w-9 flex-shrink-0'>
                <RadixHoverDropdown
                  iconNumber={624}
                  items={[
                    {
                      value: 'save_new',
                      label: 'Lưu mẫu mới',
                      icon: 7,
                      onClick: () => undefined
                    },
                    {
                      value: 'save_overwrite',
                      label: 'Lưu đè vào mẫu đang chọn',
                      icon: 75,
                      onClick: () => console.log('Overwrite current filter template')
                    },
                    {
                      value: 'delete',
                      label: 'Xóa mẫu đang chọn',
                      icon: 8,
                      onClick: () => console.log('Delete current filter template')
                    }
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherTab;
